const Logo = () => (
  <svg
    id="Laag_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    viewBox="0 0 322.67 248.63"
    style={{ paddingTop: '15px' }}
  >
    <defs>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .st0 { fill: url(#Naamloos_verloop_51); }
            .st1 { fill: url(#Naamloos_verloop_48); }
            .st2 { fill: #72be00; }
            .st3 { fill: #506314; }
            .st4 { fill: url(#Naamloos_verloop_481); }
          `,
        }}
      />
      <linearGradient
        id="Naamloos_verloop_48"
        data-name="Naamloos verloop 48"
        x1="164.03"
        y1="49.38"
        x2="241.58"
        y2="211.56"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#72be00" />
        <stop offset="1" stopColor="#eae14c" />
      </linearGradient>
      <linearGradient
        id="Naamloos_verloop_481"
        data-name="Naamloos verloop 48"
        x1="248.53"
        y1="48.53"
        x2="316.98"
        y2="103.02"
        xlinkHref="#Naamloos_verloop_48"
      />
      <linearGradient
        id="Naamloos_verloop_51"
        data-name="Naamloos verloop 51"
        x1="90.1"
        y1="60.5"
        x2="153.59"
        y2="111.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#72be00" />
        <stop offset=".12" stopColor="#8ec612" />
        <stop offset=".28" stopColor="#afcf26" />
        <stop offset=".45" stopColor="#c9d737" />
        <stop offset=".62" stopColor="#dbdc42" />
        <stop offset=".8" stopColor="#e6df49" />
        <stop offset="1" stopColor="#eae14c" />
      </linearGradient>
    </defs>
    <g transform="scale(0.8)">
      <polygon
        className="st3"
        points="108.63 174.22 104.23 181.41 99.78 174.22 95.5 174.22 102.13 184.84 102.13 192.59 106.16 192.59 106.16 184.8 112.6 174.22 108.63 174.22"
      />
      <polygon
        className="st3"
        points="119.39 184.81 127.04 184.81 127.04 181.58 119.39 181.58 119.39 177.45 128.3 177.45 128.3 174.22 115.41 174.22 115.41 192.59 128.43 192.59 128.43 189.36 119.39 189.36 119.39 184.81"
      />
      <path
        className="st3"
        d="M136.64,174.22l-5.93,18.37h3.92l1.51-4.9h6.81l1.52,4.9h3.97l-5.93-18.37h-5.87ZM137.14,184.47l2.41-7.81,2.42,7.81h-4.83Z"
      />
      <path
        className="st3"
        d="M162,185.18c1.16-.45,2.06-1.11,2.69-1.99.63-.88.94-1.98.94-3.28,0-2.03-.67-3.52-2-4.47-1.33-.96-3.32-1.43-5.96-1.43-.68,0-1.35.03-2.02.08-.67.05-1.32.13-1.95.22s-1.22.21-1.77.33v17.96h3.96v-6.8c.32.02.64.03.94.04.31.01.64.02,1.01.02.07,0,.14,0,.21,0l4.69,6.75h4.41l-5.22-7.39s.05-.01.07-.02ZM156.57,182.8c-.21-.02-.44-.04-.68-.06v-5.58c.33-.07.67-.12,1.03-.15s.74-.05,1.17-.05c.85,0,1.56.1,2.11.31.55.21.97.53,1.24.96.27.44.41.99.41,1.67,0,1.03-.32,1.78-.97,2.25-.65.46-1.63.69-2.97.69-.25,0-.48,0-.7,0-.22,0-.43-.02-.65-.04Z"
      />
      <path
        className="st3"
        d="M181.78,184.72c-.37-.69-.94-1.27-1.71-1.75-.77-.48-1.75-.86-2.94-1.15l-1.38-.36c-.91-.25-1.53-.53-1.86-.83-.33-.31-.5-.73-.5-1.27,0-.42.12-.79.37-1.12.24-.32.65-.57,1.21-.75.56-.18,1.32-.27,2.28-.27.73,0,1.45.05,2.17.15.72.1,1.37.24,1.96.42v-3.28c-.58-.17-1.24-.3-1.99-.39-.75-.09-1.54-.14-2.36-.14-2.56,0-4.47.49-5.74,1.48-1.27.98-1.9,2.35-1.9,4.11,0,1.41.41,2.54,1.23,3.39.82.86,2.04,1.49,3.64,1.89l1.39.36c1.03.26,1.73.56,2.1.88.38.32.57.77.57,1.34,0,.68-.26,1.21-.77,1.58-.51.38-1.39.56-2.62.56-.53,0-1.09-.03-1.68-.1-.59-.07-1.18-.16-1.77-.28-.59-.12-1.14-.27-1.66-.44v3.28c.75.25,1.57.44,2.46.58.89.14,1.78.21,2.66.21,1.56,0,2.88-.23,3.98-.68,1.1-.45,1.94-1.1,2.53-1.95.58-.85.88-1.86.88-3.03,0-.94-.18-1.76-.55-2.45Z"
      />
    </g>
    <g transform="scale(0.8)">
      <path
        className="st3"
        d="M62.12,242.32c-3.13-.59-2.88-1.24-2.26-1.78,13.14-8.11,23.77-17.22,23.13-28.06-.22-3.65-2.63-9.61-1.71-8.35,34.9,47.77-11.92,39.35-19.16,38.19M233.85,228.28h-27.52c.37,5.48,5.23,8.53,9.9,8.47,6.69,0,5.31-4.61,16.63-4.61-1.62,3.8-4.05,6.66-6.91,8.59-2.86,1.99-6.23,2.99-9.78,2.99-10.52,0-18.06-8.53-18.06-18.06s7.6-18.24,17.93-18.24c5.11,0,9.59,1.93,12.76,5.23,4.17,4.3,5.73,9.65,5.05,15.63M206.53,221.79h19.33c-.31-3.23-3.73-7.77-9.7-7.71-6.03,0-9.33,4.35-9.63,7.71M319.48,214.87v27.5s-8.14.83-8.14-4.91c-2.18,3.98-6.71,5.97-11.5,5.97-10.94,0-17.34-8.52-17.34-18.15,0-10.75,7.77-18.09,17.34-18.09,6.22,0,10.01,3.29,11.5,6.03v-4.97c8.02,0,8.14,6.63,8.14,6.63M290.63,225.4c0,4.29,3.05,10.44,10.38,10.44,4.54,0,7.52-2.36,9.08-5.47.81-1.49,1.18-3.11,1.31-4.79.06-1.62-.25-3.29-.93-4.79-1.43-3.23-4.6-6.03-9.51-6.03-6.59,0-10.32,5.35-10.32,10.63M147.39,237.13c0,5.87,8.15,5.24,8.15,5.24v-17.31c0-5.91,2.92-9.67,8.64-9.67h.37v-7.11c-5.16.06-7.96,2.25-9.45,5.3,0,0-1.41-5.34-7.71-5.34v28.89h0ZM200.02,208.24c-9,0-9.98,4.56-9.98,4.56l-6.68,19.32-6.09-17.84s-1.97-6.03-10.57-6.03c3.2,8.98,10.47,28.23,10.47,28.23,2.93,7.08,10.17,5.9,10.17,5.9l12.68-34.13h0ZM261.27,217.44c-.68-8.21-7.52-10.26-12.12-10.26-6.59,0-12.25,4.17-12.25,10.88.06,4.91,3.79,7.46,8.39,8.89,6.28,2.18,8.83,2.98,8.83,5.9.06,2.3-2.11,3.98-4.66,3.98-6.01,0-3.42-4.41-13.18-4.41.62,8.27,7.77,11,13.06,11,7.15,0,13.05-4.47,12.93-11.5-.06-7.34-5.97-8.95-11.44-10.44-3.23-.93-5.72-2.11-5.78-4.29,0-1.68,1.3-3.42,4.04-3.42,3.17,0,4.39,3.67,12.19,3.67M268.71,237.68c0,5.35,8.14,4.69,8.14,4.69v-27.85h5.84v-6.28h-5.84v-6.32s.62-5.55-8.14-5.55v11.87h-5.66s-1.47,6.28,5.66,6.28v23.16h0ZM143.79,214.87v27.5s-8.14.83-8.14-4.91c-2.18,3.98-6.71,5.97-11.5,5.97-10.94,0-17.35-8.52-17.35-18.15,0-10.75,7.77-18.09,17.35-18.09,6.22,0,10.01,3.29,11.5,6.03v-4.97c8.02,0,8.14,6.63,8.14,6.63M114.94,225.4c0,4.29,3.05,10.44,10.38,10.44,4.54,0,7.52-2.36,9.08-5.47.81-1.49,1.18-3.11,1.31-4.79.06-1.62-.25-3.29-.93-4.79-1.43-3.23-4.6-6.03-9.51-6.03-6.59,0-10.32,5.35-10.32,10.63"
      />
      <path
        className="st2"
        d="M76.65,195.36c21.21,36.1-67.34,52-73.46,49.12,15.88-8.66,35.96-49.82,54.38-57.34,6.67-2.72,13.12-1.03,19.08,8.21"
      />
    </g>
    <g transform="scale(0.8)">
      <path
        className="st1"
        d="M214.45,148.43c-14.04-5.25-26.27-12.83-35.36-21.92l-.23-.22c-1.4-1.27-2.8-2.59-4.22-3.94,19.71-19,34.5-37.4,45.09-56.02,4.31-7.43,8.78-16.4,9.26-26.5.54-10.17-4.06-18.43-12.63-22.68-11.3-5.6-27.17-3.16-37.8,5.79-6.51,5.11-10.83,13.96-11.87,24.31l12.74,1.27c.68-6.83,3.33-12.64,7.09-15.55l.22-.18c6.69-5.68,17.2-7.5,23.93-4.17,4,1.98,5.81,5.43,5.53,10.57-.35,7.39-4.01,14.62-7.58,20.77-10.12,17.8-24.41,35.46-43.53,53.81-5.49-4.47-11.64-8.41-18.9-10.29-7.96-1.91-15.17-.52-20.31,3.93-4.91,4.29-9.47,12.21-6.14,20.42l.12.28c2.41,5.23,7.1,9.15,13.21,11.06,7.9,2.46,17.48,1.41,24.45-2.68,2.83-1.58,5.37-3.49,7.67-5.43l.49.46c1.5,1.42,2.98,2.82,4.45,4.16,10.36,10.33,24.13,18.88,39.82,24.75,15.55,5.81,32.07,8.73,48.26,8.73,13.89,0,27.55-2.15,40.16-6.47l-4.15-12.11c-24.55,8.42-53.63,7.64-79.79-2.14ZM151.25,125.33l-.16.09c-3.87,2.29-9.71,2.92-14.2,1.52-2.61-.81-4.4-2.17-5.32-4.03-.56-1.68.93-4.27,2.73-5.84,2.57-2.23,6.69-1.67,8.8-1.17,4.4,1.14,8.48,3.57,12.37,6.57-1.36,1.07-2.76,2.05-4.23,2.86Z"
      />
      <path
        className="st4"
        d="M299.39,59.22c-8.33-7.35-18.1-10.2-27.85-10.15-1.11-6.99-5.43-16.7-11.35-26.12,15.6,3.78,37.4,5.2,57.68-6.91l-6.56-10.99c-29.99,17.9-66.23-1.04-66.58-1.22l-7.62,10.1c12.19,12.55,20.61,29.8,21.78,36.74-6.51,1.56-12.71,4.16-18.13,7.27-7.09,4.08-10.94,10.64-10.3,17.55.64,6.92,5.52,12.79,12.72,15.32l1.11.28c5.63.9,10.78-.28,14.9-3.4,7.52-5.69,10.17-16.54,11.54-25.8,7.08-.19,14.1,1.68,19.93,6.69,5.63,6.4,7.74,15.19,5.93,24.8-2.26,12.05-10.11,23.05-20,28.01l-.2.11c-11.95,6.54-26.07,5.86-35.14-1.68l-8.19,9.84c7.34,6.1,16.55,9.2,26.16,9.2,7.74,0,15.73-2.01,23.21-6.08,13.29-6.71,23.78-21.24,26.74-37.04,2.58-13.77-.71-26.56-9.26-36.02l-.51-.51ZM251.45,77.48c-.78.59-2.08,1.32-4.57,1.05-2.11-.9-3.53-2.51-3.69-4.22-.17-1.82,1.27-3.74,3.94-5.28,3.12-1.79,6.55-3.38,10.14-4.61-1.1,5.45-2.85,10.81-5.81,13.05Z"
      />
      <path
        className="st0"
        d="M147.84,10.45c-2.65,2.71-5.26,5.82-8.03,9.1-11.12,13.21-26.36,31.3-63.62,47l4.97,11.8c17.88-7.54,31.05-15.58,41.21-23.44-15.73,30.23-32.28,66.71-40.61,95.69l12.3,3.54c12.79-44.49,45.61-107.33,63.75-135.78l-9.98-7.91Z"
      />
    </g>
  </svg>
);

export default Logo;
